import { createI18n } from 'vue-i18n'
import en from './en.json'
import da from './da.json'

export const defaultLocale = 'en-US'

type MessageSchema = typeof en

export const i18n = createI18n<[MessageSchema], 'en-US' | 'da-DK'>({
    legacy: false,
    fallbackLocale: defaultLocale,
    messages: {
        'en-US': en,
        'da-DK': da
    }
})